export const PROXY_TYPES = ['SOCKS5', 'IP', 'HTTP', 'SOCKS5_HOSTNAME'] as const;

export type ProxyType = (typeof PROXY_TYPES)[number];

export const PROXY_COPY_NAME_SUFFIX = '(Copy)';
